import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  browserLocalPersistence
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyB48I3LLu2eiPXxK4mZtMl6ANw3Am90bR4",
    authDomain: "figure-it-out-app.firebaseapp.com",
    projectId: "figure-it-out-app",
    storageBucket: "figure-it-out-app.firebasestorage.app",
    messagingSenderId: "822788869719",
    appId: "1:822788869719:web:d9e753b47d76bfa88add12",
    measurementId: "G-V0Y9RZR972",
};

const app = initializeApp(firebaseConfig);

export const analytics =
    typeof window !== "undefined"
        ? getAnalytics(app)
        : null;

export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;